module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_7_4.cf15118f.png";